import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-rental',
  templateUrl: './main-rental.component.html',
  styleUrls: ['./main-rental.component.scss']
})
export class MainRentalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
